import React, { useState } from "react";
//#region types
import ReportDocumentsImg from "images/hand-paperplane@2x.png";
import BlueBackgroundCurve from "images/wave-right-overlay.png";
import { IconDefinitionConstants } from "utils/constants";
import { TranslationKeys } from "translations";
import { DocumentDraftReportBannerProps } from "models/propTypes/documentDraftPropTypes";
//#endregion
//#region components
import { Grid, Hidden } from "@mui/material";
import { ActionLinkButton, Icon } from "components/common";
import CopyButton from "components/common/buttons/copyButton";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const DocumentDraftReportBanner: React.FC<DocumentDraftReportBannerProps> = (props) => {
  const { readMoreInfo, userEmail, title, subTitle, showImage, useFullWidth } = props;
  const [hovered, setHovered] = useState(false);
  const readMoreButtonClick = () => window.open(props.readMoreInfo?.url);

  return (
    <Grid container item className={cssExports.documentDraftsBannerContainer}>
      <Grid container item direction="row" wrap="nowrap">
        {showImage ? (
          <Hidden lgDown={!useFullWidth} mdDown>
            <Grid item className={cssExports.imageContainer}>
              <img src={ReportDocumentsImg} className={cssExports.image} />
              <Grid item className={cssExports.imageBackgroundCurveContainer}>
                <img src={BlueBackgroundCurve} className={cssExports.imageBackgroundCurve} />
              </Grid>
            </Grid>
          </Hidden>
        ) : (
          <></>
        )}
        <Grid container item xs className={cssExports.bannerContentContainer} alignContent="space-between">
          <Grid container item direction={"column"} justifyContent={"center"} rowGap={0.5}>
            <Grid item className={cssExports.documentDraftsBannerTitle}>
              {title}
            </Grid>

            <Grid item className={cssExports.documentDraftsBannerSubTitle}>
              {subTitle}
            </Grid>
            {readMoreInfo ? (
              <Grid item>
                <ActionLinkButton
                  onClick={readMoreButtonClick}
                  endIcon={<Icon icon={IconDefinitionConstants.WOpenExternal} />}
                >
                  {readMoreInfo.text}
                </ActionLinkButton>
              </Grid>
            ) : (
              <></>
            )}
          </Grid>
          <Grid container className={cssExports.formControlDescription} direction={"column"}>
            {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.DocumentDraft.YoureMailAddress)}
            <Grid item onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
              <CopyButton copyText={userEmail} showCopyIcon={hovered}>
                {userEmail}
              </CopyButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default DocumentDraftReportBanner;
